function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { FileUploaderContainer, Title } from './elements';
import { ImagePreview } from './ImagePreview';
import { FileUploadButton } from './FileUploadButton';
import { isComponentType, attachSubComponents } from '../../util';
const filterOutUploadButton = children => children.filter(el => !isComponentType(el, FileUploadButton));
export const FileUploader = attachSubComponents('FileUploader', /*#__PURE__*/forwardRef(({
  children,
  ...props
}, fRef) => {
  // handle the case when children is not an array
  children = [children].flat();
  const hasImage = children.find(el => isComponentType(el, ImagePreview) && el.props.imageSrc);
  if (hasImage) {
    children = filterOutUploadButton(children);
  }
  return /*#__PURE__*/React.createElement(FileUploaderContainer, _extends({}, props, {
    ref: fRef,
    "data-aui": "file-uploader"
  }), children);
}), {
  Title,
  ImagePreview,
  FileUploadButton
});